<style scoped>
.form-dashed{
    border:dashed 1px rgb(211, 211, 211);
    margin:2px;
    padding:10px 4px;
}
</style>
<script>

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { notify } from '@/helpers/notify' 


export default {
  page: {
    title: "Sms Yönetimi",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
        title: "SMS YÖNETİMİ",
        form:{
            gunkala: {
                active:false,
                content:''
            },
            surebitti: {
                active:false,
                content:''
            },
            onkayit: {
                active:false,
                content:''
            }
        },
        submitted:false,
        items: [
            {
                text: "ANASAYFA",
                href: "/",
            },
            {
                text: "SMS YÖNETİMİ",
                active: true,
            },
        ],
        };
    },
    mounted(){
        this.getData()
    },
    methods:{
        handleSubmit() {
            this.submitted = true;
          
            
            this.$http.put('/sms-schema', this.form)
                .then(response => {
            
                if(response.data.error){
                    return notify.error(response.data.message)
                }

                return notify.success(response.data.message)
            })
            this.submitted = false;
        },
        getData(){
              
            this.$http.post('/sms-schema')
                .then(response => {
                    response.data.map(e=>{
                        this.form[e.code] = { active: e.status, content: e.trcontent}
                    })
                })
        }
    },
};
</script>

<template>
<Layout>
  <PageHeader :title="title" :items="items" />

    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <form class="needs-validation" @submit.prevent="handleSubmit">
                            <div class="row form-dashed mb-2">
                                <div class="col-sm-2 col-form-label">Gün kala sms metni</div>
                                <div class="col-md-2" style="align-self: center;">
                                    <input type="checkbox" v-model="form.gunkala.active" /> Aktif
                                </div>
                                <div class="col-md-8">
                                    <input  
                                        v-model="form.gunkala.content"
                                        type="text"
                                        placeholder="Mesaj Metni" 
                                        class="form-control">
                                </div>
                            </div>
                            <div class="row form-dashed mb-2">
                                <div class="col-sm-2 col-form-label">Süre Bitimi</div>
                                <div class="col-md-2" style="align-self: center;">
                                    <input type="checkbox" v-model="form.surebitti.active" /> Aktif
                                </div>
                                <div class="col-md-8">
                                    <input  
                                        v-model="form.surebitti.content"
                                        type="text"
                                        placeholder="Mesaj Metni" 
                                        class="form-control">
                                </div>
                            </div>   
                            <div class="row form-dashed mb-2">
                                <div class="col-sm-2 col-form-label">Ön Kayıt</div>
                                <div class="col-md-2" style="align-self: center;">
                                    <input type="checkbox" v-model="form.onkayit.active" /> Aktif
                                </div>
                                <div class="col-md-8">
                                    <input  
                                        v-model="form.onkayit.content"
                                        type="text"
                                        placeholder="Mesaj Metni" 
                                        class="form-control">
                                </div>
                            </div>  
                            <div class="col-md-12">
                                <div class="mb-3 d-flex justify-content-end">
                                    <button class="btn btn-warning" type="submit">Güncelle</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- end row-->
  </Layout>
</template>